import { z } from 'zod';
import { BooleanOptional, StringOptional } from './schemaTypes';
export const AccountSchema = z.object({
    engineURL: StringOptional,
    showUserPhoneInput: BooleanOptional,
    openCheckinPageOnProfileControlsClick: BooleanOptional,
    showCommunications: BooleanOptional,
    showSubscribeCheckbox: BooleanOptional,
    initialStayLoggedIn: BooleanOptional
});
